import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

/** The shared app-wide error / rejection icon (80×80). */
export const ErrorIcon = ({ fill, ...props }: SvgProps) => (
    <Svg width={80} height={80} viewBox="0 0 80 80" fill="none" {...props}>
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0ZM37 52V58H43V52H37ZM37 22L38 48H42L43 22H37Z"
            fill={fill ?? ds.colorValue.background.danger.strong}
        />
    </Svg>
);
